'use client';

import { Button } from '@koda/koda-components/atoms/Button';
import { Display } from '@koda/koda-components/atoms/Display';
import Grid from '@koda/koda-components/atoms/Grid';
import { Paragraph } from '@koda/koda-components/atoms/Paragraph';
import { useTranslations } from 'next-intl';
import { useRouter } from '../../../../i18n/routing';

export default function LicenseTypeError({ reset, error }: { reset: () => void; error: Error & { digest?: string } }) {
  const t = useTranslations('errorPage');
  const router = useRouter();

  return (
    <Grid className="pb-6 pt-menu-height">
      <div className="col-span-4 gap-x-4 gap-y-in-text sm:col-span-6 sm:col-start-2 lg:col-span-4 lg:col-start-3">
        <Display tag="h1" textSize="4xl">
          {t('header')}
        </Display>
        <Paragraph heading={t('description')} text={error.message} />
      </div>
      <div className="col-span-4 flex gap-x-4 gap-y-in-text sm:col-span-6 sm:col-start-2 lg:col-span-4 lg:col-start-3">
        <Button buttonType="button" onClick={() => router.back()} className="w-fit" variant="secondaryDark">
          {t('return')}
        </Button>
        <Button buttonType="button" onClick={() => reset()} className="w-fit">
          {t('tryAgain')}
        </Button>
      </div>
    </Grid>
  );
}
